import axios from '../api/axios'

export default {
    keyList({params, callback}){ // 列表
        axios.post(`/v1/admin/keywords/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    keyList({params, callback}){ // 列表
        axios.post(`/v1/admin/keywords/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    nums({callback}){ // 数量
        axios.post(`/v1/admin/keywords/missingKeywordsCount`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getMissingKeywordsList({params,callback}){ // 未补充列表
        axios.post(`/v1/admin/keywords/missingKeywordsList`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    editKeywords({params,callback}){ 
        axios.put(`/v1/admin/keywords/update`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    addKeywords({params,callback}){ 
        axios.post(`/v1/admin/keywords/add`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    deleteKeywords({params,callback}){ 
        axios.delete(`/v1/admin/keywords/delete/${params.id}`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getKeywords({params,callback}){ 
        axios.get(`/v1/admin/keywords/details/${params.id}`,params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/category.js